import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_TASK_GROUP_LIST = "GET_TASK_GROUP_LIST";

export const service = async (data) => {
  const options: object = {
    url: `/Api/TaskGroups/GetTaskGroupList`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_TASK_GROUP_LIST, service, mock);
